export default __webpack_public_path__ + "static/media/HAR_Icon_1_BlueGreen.40e46ea9.svg";